<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/13sPfP4/tc-custom/9781634868303.jpg?1723408223263" alt="This image is the cover for the book Making Wise Decisions"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Making Wise Decisions
      </h1>
      <p class="bookDescription body article font2">
        <p>At a friend’s wedding reception, Strider is berated by a man who assumes Strider is his son’s lover. He doesn’t even know the guy! The man apologizes and offers Strider a sales position at his company. After the reception Ryan, the man’s son, calls to apologize for his father. The two start talking, and Strider confesses his attraction to men, though he’s only ever dated girls. The two find they have a lot in common, and one date leads to another as their relationship deepens.<br/><br/>On top of the world with a new love and a new job, Strider accidentally comes out to his boss, putting his position in jeopardy. Can Strider learn to accept who he is and come out, celebrating his new relationship with Ryan while working for Ryan’s homophobic father?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        David O. Sullivan
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3fb29f82